import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Import your translation files
import en from "@/locales/en";
import fr from "@/locales/fr";

const resources = {
  en: { translation: en },
  fr: { translation: fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Clamp detected languages to the two we ship: browser locales like
    // "en-US" resolve to "en", anything else (es, de, ...) falls back to
    // fallbackLng instead of leaking into i18n.language (and then into
    // field.label[locale] lookups, which only have en/fr keys).
    supportedLngs: ["en", "fr"],
    fallbackLng: "en",
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
